module.exports = __webpack_public_path__ + "img/OffSpécifique lumière écran.1eb9b9b5.gif";